import {
  SET_EDIT_CONFIG,
  UPDATE_EDIT_CONFIG,
  RESET_EDIT_CONFIG,
} from "../actions";
import { mergeDeeply } from "../../src/utils/mergeUtils";

const editConfig = (state = {}, action) => {
  switch (action.type) {
    case SET_EDIT_CONFIG:
      return action.config;
    case UPDATE_EDIT_CONFIG:
      return mergeDeeply(state, action.config);
    case RESET_EDIT_CONFIG:
      return {};
    default:
      return state;
  }
};

export default editConfig;
